// ———————————————————————————————————————————————
// Cliente de precios con axios preconfigurado.
// ———————————————————————————————————————————————
import api from "./axios"; // asume mi axios con baseURL y JWT ya está aquí.

export function comparePrices(params) {
  // params: { q, lat, lng, radius_km, limit, offset }
  return api.get("/prices/compare", { params });
}

export function buildCart(payload) {
  // payload: { strategy, lat, lng, radius_km, items: [{product_id?, query?, qty}] }
  return api.post("/prices/cart/build", payload);
}
